import RecommendationApi from '../api/RecommendationApi';
import RecommendationConstants from '../constants/RecommendationConstants';

function getRecommendations(id) {
  return {
    id,
    types: [
      RecommendationConstants.RECOMMENDATION_REQUEST,
      RecommendationConstants.RECOMMENDATION_SUCCESS,
      RecommendationConstants.RECOMMENDATION_ERROR
    ],
    apiRequest: (state, client) => RecommendationApi.fetchRecommendations(id, client)
  };
}

export default {
  getRecommendations
};
